const STORAGE_KEY = "aequia:last-tenant-by-user";

type TenantMemory = Record<string, string>;

function readMemory(): TenantMemory {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null
      ? (parsed as TenantMemory)
      : {};
  } catch {
    return {};
  }
}

export function tenantMemoryKey(
  userId: string | undefined,
  email: string | undefined,
): string | null {
  return userId ?? email ?? null;
}

export function rememberTenantForUser(
  userKey: string | null,
  tenantId: string,
): void {
  if (!userKey) return;
  const memory = readMemory();
  memory[userKey] = tenantId;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(memory));
}

export function getRememberedTenantForUser(
  userKey: string | null,
): string | null {
  if (!userKey) return null;
  return readMemory()[userKey] ?? null;
}
